import { atom } from 'jotai';

export const renderingsEstateIdAtom = atom<string | undefined>(undefined);
export const renderingsProjectIdAtom = atom<string | undefined>(undefined);

export const renderingsHasRelationAtom = atom((get) => {
  return Boolean(get(renderingsEstateIdAtom) || get(renderingsProjectIdAtom));
});

export const renderingsRelationAtom = atom((get) => ({
  estateId: get(renderingsEstateIdAtom),
  projectId: get(renderingsProjectIdAtom),
}));
